import { SubAPI } from "./SubAPI"; // "none" leaves the current by-others flag untouched; the others set it explicitly.
export class Openings extends SubAPI {
    list(input) { return this.fetcher.get("/api/openings", input); }
    getByIds(input) { return this.fetcher.post("/api/openings/by-id", input); }
    listScreenElevations(input) { return this.fetcher.get("/api/opening/screen-elevations", input); }
    updateScreenElevation(input) { return this.fetcher.post("/api/opening/screen-elevation", input); }
    listDrawingWallLabels(input) { return this.fetcher.get("/api/opening/drawing-wall-labels", input); }
    updateDrawingWallLabel(props) { return this.fetcher.post("/api/opening/drawing-wall-label", props); }
    listDoorElevations(input) { return this.fetcher.get("/api/opening/door-elevations", input); }
    updateDoorElevation(input) { return this.fetcher.post("/api/opening/door-elevation", input); }
    upsert(input) { return this.fetcher.post("/api/opening", input); }
    bulkUpsert(input) { return this.fetcher.post("/api/opening/bulk", input); }
    reSequence(input) { return this.fetcher.post("/api/opening/re-sequence", input); }
    reOrder(input) { return this.fetcher.post("/api/opening/re-order", input); }
    resetConflict(input) { return this.fetcher.post("/api/opening/reset-conflict", input); }
    recalculate(input) { return this.fetcher.post("/api/opening/recalculate", input); }
    release(input) { return this.fetcher.post("/api/release", input); }
    releaseTask(input) { return this.fetcher.post("/api/release/task", input); }
    listFrameProfiles(props) { return this.fetcher.get("/api/opening/frame-profiles", props); }
    listAnchors(props) { return this.fetcher.get("/api/opening/anchors", props); }
    listWoodDetails(props) { return this.fetcher.get("/api/opening/wood-detail", props); }
    updateWoodDetail(input) { return this.fetcher.post("/api/opening/wood-detail", input); }
    listDoorCores(props) { return this.fetcher.get("/api/opening/door-cores", props); }
    upsertDoorCore(input) { return this.fetcher.post("/api/opening/door-core", input); }
    listDoorSeams(props) { return this.fetcher.get("/api/opening/door-seams", props); }
    upsertDoorSeam(input) { return this.fetcher.post("/api/opening/door-seam", input); }
}
